import clsx from 'clsx';
import Image from 'next/image';

interface PhotoFeatureCardProps {
    title: string;
    copy: string;
    imageUrl: string;
    imageAlt: string;
    align?: string;
    index: number;
}

const PhotoFeatureCard = ({
    title,
    copy,
    imageUrl,
    imageAlt,
    index,
}: PhotoFeatureCardProps) => {
    const isLeft = index % 2 === 0;
    const containerClasses = clsx(
        'flex',
        'flex-col',
        'items-center',
        'border',
        'border-gray-200',
        'rounded-lg',
        'shadow-[0px_0px_0px_1px_rgba(0,0,0,0.06),0px_1px_1px_-0.5px_rgba(0,0,0,0.06),0px_3px_3px_-1.5px_rgba(0,0,0,0.06),_0px_6px_6px_-3px_rgba(0,0,0,0.06),0px_12px_12px_-6px_rgba(0,0,0,0.06),0px_24px_24px_-12px_rgba(0,0,0,0.06)]',
        'md:flex-row',
        'bg-[#e1e8e1]',
        'overflow-hidden',
        'mb-8',
        'w-full md:w-3/4',
        isLeft ? 'md:mr-auto' : 'md:ml-auto'
    );
    return (
        <div className={containerClasses}>
            {isLeft && (
                <Image
                    unoptimized={true}
                    className="object-cover w-full h-60"
                    src={imageUrl}
                    width={140}
                    height={140}
                    alt={imageAlt || ''}
                />
            )}
            <div className="flex flex-col justify-between p-4 leading-normal">
                <h5 className="mb-4 text-2xl font-bold tracking-tight">
                    {title}
                </h5>
                <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                    {copy}
                </p>
            </div>
            {!isLeft && (
                <Image
                    unoptimized={true}
                    className="object-cover w-full h-auto max-h-64"
                    src={imageUrl}
                    width={200}
                    height={200}
                    alt={imageAlt || ''}
                />
            )}
        </div>
    );
};

export default PhotoFeatureCard;
